import {useEffect} from "react";
import {connect} from "react-redux";
import {getBranchUsers} from "../store/logIn";
import {FormControl, InputLabel, MenuItem, Select, Box} from "@mui/material";
import {useTranslation} from "react-i18next";

/**
 * Admin uchun tashkilot filter.
 * Props:
 *   onFilter({regionId}) — tanlanganda chaqiriladi
 */
function AdminFilter(props) {
    const {t} = useTranslation()

    useEffect(() => { props.getBranchUsers() }, [])

    const branches = props.branch_users || []

    function handleChange(val) {
        props.onFilter({regionId: val, viloyatId: ''})
    }

    return (
        <Box sx={{display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center', mb: 2}}>
            <FormControl size="small" sx={{minWidth: 260}}>
                <InputLabel>{t('tashkilotlar')}</InputLabel>
                <Select
                    defaultValue=""
                    label={t('tashkilotlar')}
                    onChange={e => handleChange(e.target.value)}
                    sx={{borderRadius: '8px'}}
                >
                    <MenuItem value="">{t('all')}</MenuItem>
                    {branches.map(b => (
                        <MenuItem key={b.id} value={b.id}>
                            {b.display_name || b.user_name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    )
}

export default connect(
    props => ({branch_users: props.login.branch_users}),
    {getBranchUsers}
)(AdminFilter)
